import type { HTMLAttributes, ReactNode } from "react";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  variant?: "default" | "outlined";
  padding?: "none" | "sm" | "md" | "lg";
}

const paddingStyles = {
  none: "",
  sm: "p-3",
  md: "p-4",
  lg: "p-6",
};

export function Card({
  children,
  header,
  footer,
  variant = "default",
  padding = "md",
  className = "",
  ...props
}: CardProps) {
  const baseStyles =
    variant === "default"
      ? "bg-white dark:bg-neutral-800 shadow-md"
      : "bg-transparent border border-neutral-200 dark:border-neutral-700";

  return (
    <div
      className={`
        rounded-lg overflow-hidden
        ${baseStyles}
        ${className}
      `}
      {...props}
    >
      {header && (
        <div className="px-4 py-3 border-b border-neutral-200 dark:border-neutral-700 font-medium">
          {header}
        </div>
      )}
      <div className={paddingStyles[padding]}>{children}</div>
      {footer && (
        <div className="px-4 py-3 border-t border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-900/50">
          {footer}
        </div>
      )}
    </div>
  );
}
